export const projects = [
  {
    title: "Home Automation",
    subtitle: "ESP32 home automation",
    description:
      "Built a system controlled by a telegram bot to control home appliances like lights and fans",
    image: "./project-1.gif",
    link: "https://github.com/butasi",
  },
  {
    title: "LED chaser",
    subtitle: "Arduino Mega",
    description:
      "Arduino Mega 2560 with Light Emitting Diodes",
    image: "./project-2.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Servo Motor",
    subtitle: "Servo modules",
    description:
    "Arduino Mega 2560 with Light Servo motors",
    image: "./project-3.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Epic Todo App",
    subtitle: "React Hooks",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-4.gif",
    link: "https://reactbootcamp.com",
  },
];

export const testimonials = [
  {
    quote:
      "Throughout the attachment period, Rodgers was hardworking, cooperative, punctual, and always ready to work late whenever there was pressure of work to meet deadlines.",
    image: "https://www.kefri.org/assets/resume/mulatya.png",
    name: "James M.Mbugua",
    company: "KEFRI",
    link: "https://www.kefri.org/home.html"
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://media-exp1.licdn.com/dms/image/C5103AQFcboxA0xysRQ/profile-displayphoto-shrink_200_200/0/1516854548034?e=2147483647&v=beta&t=Tazx_hd1kUSWb_MUVJlYmeAlcSfn7Psbfh78beGJlSU",
    name: "Rodgers Butasi",
    company: "butasi.github.io",
    link: "butasi.github.io",
  },
];

export const skills = [
  "Linux",
  "Arduino",
  "React",
  "Laravel",
  "Next.js",
  "Node",
  "MySQL",
  "CodeIgniter",
];



// WEBPACK FOOTER //
// ./src/data.js